// SignedOut.jsx
import React, { useEffect } from "react";
import { Box, Card, CardContent, CardActions, Button, Typography, Divider } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import styles from "./SignedOut.styles";
import { login, logout } from "../utils/auth";
import { useLocation } from "react-router-dom";

export default function SignedOut() {
  const location = useLocation();
  const search = new URLSearchParams(location.search || "");
  const reason = search.get("reason") || "";

  useEffect(() => {
    try { window.history.replaceState(null, "", "/signed-out"); } catch {}
  }, []);

  const signIn = () => {
    login('/home');
  };

  const title = reason === "forbidden" ? "Access denied" : "You’ve been signed out";
  const subtitle =
    reason === "forbidden"
      ? "You are signed in but you don’t have access to this application or page."
      : "Your session has ended, or you don’t have access to this page.";

  const caption =
    reason === "forbidden"
      ? "If you believe you should have access, contact your administrator."
      : "To continue, please sign in with your Microsoft account.";

  return (
    <Box sx={styles.page}>
      <Card elevation={8} sx={styles.card}>
        <CardContent sx={styles.content}>
          <Box aria-hidden sx={styles.badge}><LogoutRoundedIcon fontSize="large" /></Box>
          <Typography variant="h6" component="h1" sx={styles.title}>{title}</Typography>
          <Typography variant="body2" sx={styles.subtitle}>
            {subtitle}
          </Typography>
          <Divider sx={{ width: "100%", my: 2 }} />
          <Typography variant="caption" sx={styles.caption}>
            {caption}
          </Typography>
        </CardContent>
        <CardActions sx={styles.actions}>
          {reason === "forbidden" ? (
            <Button variant="contained" onClick={() => logout()} sx={styles.btnPrimary}>
              Sign out
            </Button>
          ) : (
            <Button variant="contained" onClick={signIn} sx={styles.btnPrimary}>
              Sign in with Microsoft
            </Button>
          )}
        </CardActions>
      </Card>
    </Box>
  );
}
